const VARIABLES = {
    SUMMARY: '.nf-infobox.summary',
    TYPES: {
        IMAGE_SELECT: 'is-listimage-layout-0',
        IMAGE_SELECT_SMALL: 'is-listimage-layout-2',
        IMAGE_SELECT_DETAIL: 'is-listimage-layout-1',
        SELECT: 'listselect-container',
        TEXT: 'textbox-container',
        EMAIL: 'email-container',
        FIRSTNAME: 'firstname-container',
        LASTNAME: 'lastname-container',
        ADDRESS: 'address-container',
        ZIP: 'zip-container',
        PHONE: 'phone-container',
        DATE: 'date-container',
        TIME: 'is-radio-time',
        NUMBER: 'number-container',
        RADIO: 'listradio-container',
        CHECKBOX: 'listcheckbox-container',
        TEXTAREA: 'textarea-container',
    }
};

window.form_summary = {};


window.addEventListener('DOMContentLoaded', () => {

    /**
     * A handler for the appointment form.
     * @constructor
     */
    const summaryFormHandler = Marionette.Object.extend({

        initialize: function () {
            this.listenTo( Backbone.Radio.channel('fields'), 'change:model', (fieldModel) => this.updateSummary(fieldModel,true) );
            this.listenTo(Backbone.Radio.channel('form'), 'render:view', this.onFormRender);
            this.summaryVisible = false;

            // Create a MutationObserver to watch for changes in the DOM
            this.observer = new MutationObserver(this.checkSummaryVisibility.bind(this));
            this.observer.observe(document.body, { childList: true, subtree: true });
        },

        onFormRender: function() {
            // Update all summary fields when the form is rendered
            Object.keys(window.form_summary).forEach(fieldKey => {
                const fieldModel = Backbone.Radio.channel('fields').request('get:field', fieldKey);
                if (fieldModel) {
                    this.updateSummary(fieldModel);
                }
            });
        },

        checkSummaryVisibility: function(mutations) {
            for (let mutation of mutations) {
                if (mutation.type === 'childList') {
                    const summaryElement = document.querySelector(VARIABLES.SUMMARY);
                    if (summaryElement && !this.summaryVisible) {
                        this.summaryVisible = true;
                        this.updateAllFields();
                        break;
                    } else if (!summaryElement) {
                        this.summaryVisible = false;
                    }
                }
            }
        },

        updateAllFields: function() {
            const allFields = Backbone.Radio.channel('fields').request('get:collection');
            if (allFields && typeof allFields.each === 'function') {
                allFields.each((fieldModel) => {
                    this.updateSummary(fieldModel, true);
                });
            }
            this.removeInvisibleFields();
        },

        isFieldVisible: function(fieldElm) {
            return fieldElm && (fieldElm.offsetParent !== null || getComputedStyle(fieldElm).display !== 'none');
        },

        removeInvisibleFields: function() {
            Object.keys(window.form_summary).forEach(fieldKey => {
                const fieldModel = Backbone.Radio.channel('fields').request('get:field', fieldKey);
                if (fieldModel) {
                    const fieldElm = document.getElementById(`nf-field-${fieldModel.attributes.id}-container`);
                    if (!this.isFieldVisible(fieldElm)) {
                        delete window.form_summary[fieldKey];
                    }
                }
            });
        },

        updateSummary: function(fieldModel, forceUpdate = false) {

            const fieldKey = fieldModel.attributes.key;
            const fieldElm = document.getElementById(`nf-field-${fieldModel.attributes.id}-container`);

            if (!this.isFieldVisible(fieldElm)) {
                delete window.form_summary[fieldKey];
                if (forceUpdate || this.summaryVisible) {
                    this.renderSummary();
                }
                return;
            }

            if(!this.getSummary) {
                return;
            }

            if(fieldElm && (forceUpdate || this.summaryVisible)) {

                if(
                    fieldElm.classList.contains(VARIABLES.TYPES.TEXT) ||
                    fieldElm.classList.contains(VARIABLES.TYPES.EMAIL) ||
                    fieldElm.classList.contains(VARIABLES.TYPES.FIRSTNAME) ||
                    fieldElm.classList.contains(VARIABLES.TYPES.LASTNAME) ||
                    fieldElm.classList.contains(VARIABLES.TYPES.TEXTAREA) ||
                    fieldElm.classList.contains(VARIABLES.TYPES.ZIP) ||
                    fieldElm.classList.contains(VARIABLES.TYPES.ADDRESS) ||
                    fieldElm.classList.contains(VARIABLES.TYPES.PHONE)
                ) {
                    window.form_summary[fieldKey] = fieldModel.attributes.value;
                }

                if(fieldElm.classList.contains(VARIABLES.TYPES.IMAGE_SELECT)) {
                    const label = fieldElm.querySelector(`input[value="${fieldModel.attributes.value}"] + label .listimage__text`)
                    window.form_summary[fieldKey] = label ? label.innerText : fieldModel.attributes.value;
                }

                if(fieldElm.classList.contains(VARIABLES.TYPES.IMAGE_SELECT_SMALL)) {
                    const label = fieldElm.querySelector(`input[value="${fieldModel.attributes.value}"] + label .listimage__text`)
                    window.form_summary[fieldKey] = label ? label.innerText : fieldModel.attributes.value;
                }

                if(fieldElm.classList.contains(VARIABLES.TYPES.IMAGE_SELECT_DETAIL)) {
                    const label = fieldElm.querySelector(`input[value="${fieldModel.attributes.value}"] + label .c-listimage-card__content-title`)
                    window.form_summary[fieldKey] = label ? label.innerText : fieldModel.attributes.value;
                }

                if(fieldElm.classList.contains(VARIABLES.TYPES.DATE)) {
                    window.form_summary[fieldKey] = fieldModel.attributes.value;
                }

                if(fieldElm.classList.contains(VARIABLES.TYPES.TIME)) {
                    if(fieldModel.attributes.value) {
                        const label = fieldElm.querySelector(`input[value="${fieldModel.attributes.value}"] + label`);
                        if(label) {
                            if(label.innerText.toLowerCase().includes('bestimmten') || label.innerText.toLowerCase().includes('ganztägig')) {
                                window.form_summary[fieldKey] = label.innerText;
                            } else {
                                window.form_summary[fieldKey] = label.innerText + ' Uhr';
                            }
                        } else {
                            window.form_summary[fieldKey] = label ? label.innerText : fieldModel.attributes.value;
                        }

                    } else {
                        window.form_summary[fieldKey] = null;
                    }
                }

                if(fieldElm.classList.contains(VARIABLES.TYPES.SELECT)) {
                    const select = fieldElm.querySelector(`select`);
                    window.form_summary[fieldKey] = select ? select.selectedOptions[0].textContent : fieldModel.attributes.value;
                }

                if(fieldElm.classList.contains(VARIABLES.TYPES.CHECKBOX)) {
                    if(fieldModel.attributes.value) {
                        let values = [];
                        // First ensure we have an array to work with
                        const valueArray = Array.isArray(fieldModel.attributes.value)
                            ? fieldModel.attributes.value
                            : [fieldModel.attributes.value];

                        valueArray.forEach(value => {
                            const label = fieldElm.querySelector(`input[value="${value}"] + label`);
                            values.push(label ? label.innerText : value);
                        });
                        window.form_summary[fieldKey] = values.join(', '); 
                    } else {
                        window.form_summary[fieldKey] = null;
                    }
                }

            }

            if (forceUpdate || this.summaryVisible) {
                this.renderSummary();
            }

        },

        renderSummary: function() {
            const summaryElm = document.querySelector(VARIABLES.SUMMARY);
            if (summaryElm) {
                Object.keys(window.form_summary).forEach((key) => {
                    const summaryItem = summaryElm.querySelector(`[data-summary-value="${key}"]`);
                    if (summaryItem) {
                        summaryItem.innerText = window.form_summary[key] || '';
                    }
                });
            }
        },

        getSummary: function() {
            const summaryElm = document.querySelector(VARIABLES.SUMMARY);
            return !!summaryElm;

        }
    });


    jQuery( document ).ready( function( $ ) {
        // Instantiate our custom controller, defined above.
        new summaryFormHandler();
    });

}, { once: true })